import _ from 'lodash';

import {
  FILTERS_SET_CURRENT_CATEGORY,
  FILTERS_SET_CURRENT_GROUP,
  FILTERS_SET_STATE,
  FILTERS_SET_VALUES
} from './types';

const normalizeDataSource = data => {
  _.forEach(data, (values) => {
    _.forEach(values.fields, (field) => {
      if (field.datasource) {
        field.dataSource = field.datasource;
        delete field.datasource;
      }
    });
  });
  return data;
};

export const mutations = {
  [FILTERS_SET_STATE]: (state, payload) => {
    if (_.size(payload.categories)) {
      state.filters.categories = payload.categories;

      if (!_.some(payload.categories, c => c.id === state.filters.currentCategory)) {
        const index = _.findIndex(payload.categories, c => c.default);
        state.filters.currentCategory = payload.categories[index > -1 ? index : 0].id;
      }
    } else {
      state.filters.categories = [];
      state.filters.currentCategory = '';
    }

    if (payload.values) {
      state.filters.values = payload.values;
    }

    state.filters.id = payload.id;
    state.filters.data = normalizeDataSource(payload.filters);
    state.filters.params = payload.params;
    state.filters.isExportDetail = payload.isExportDetail;
  },

  [FILTERS_SET_CURRENT_CATEGORY]: (state, payload) => {
    state.filters.currentCategory = payload;
  },

  [FILTERS_SET_CURRENT_GROUP]: (state, payload) => {
    state.filters.currentGroup = payload;
  },

  [FILTERS_SET_VALUES]: (state, payload) => {
    state.filters.values = payload;
  }
};
